import React from "react";
import PropTypes from "prop-types";

const initialsOf = (name) => name
  .replace(/[^A-Za-z0-9 ]/g, "")
  .split(" ")
  .filter(Boolean)
  .slice(0, 2)
  .map((word) => word[0])
  .join("")
  .toUpperCase();

const plural = (count, singular, pluralWord = `${singular}s`) => (count === 1 ? singular : pluralWord);

export const collectionContentsLabel = (wholeSeriesCount, singleEventCount) => {
  const parts = [];
  if (wholeSeriesCount > 0) parts.push(`${wholeSeriesCount} whole series`);
  if (singleEventCount > 0) parts.push(`${singleEventCount} ${plural(singleEventCount, "event")}`);
  return parts.length > 0 ? parts.join(" · ") : "Nothing added yet";
};

const CollectionNameCell = ({ name, venueName, showUrl, wholeSeriesCount, singleEventCount }) => (
  <div className="team-member-info series-name-cell">
    <div className="series-name-avatar collections-index-initials" aria-hidden="true">
      {initialsOf(name)}
    </div>
    <div className="team-member-details">
      <div className="series-name-title">
        <a href={showUrl} className="stretched-link series-name-link">{name}</a>
      </div>
      <div className="series-name-venue">
        {[venueName, collectionContentsLabel(wholeSeriesCount, singleEventCount)].filter(Boolean).join(" · ")}
      </div>
    </div>
  </div>
);

CollectionNameCell.propTypes = {
  name: PropTypes.string.isRequired,
  venueName: PropTypes.string,
  showUrl: PropTypes.string.isRequired,
  wholeSeriesCount: PropTypes.number,
  singleEventCount: PropTypes.number,
};

CollectionNameCell.defaultProps = {
  venueName: undefined,
  wholeSeriesCount: 0,
  singleEventCount: 0,
};

export default CollectionNameCell;
